import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { partnerApiPath } from '../apiPath';
import { partnerHttpClient } from '../httpClient';
import { CuratorWishlistPlatformSchema } from './curatorWishlist.schema';

const PostCuratorWishlistRequestSchema = z
  .object({
    curatorId: z.string().min(1),
    platform: CuratorWishlistPlatformSchema,
    brandId: z.string().min(1),
  })
  .describe('PostCuratorWishlistRequestSchema');

export type PostCuratorWishlistRequest = z.infer<typeof PostCuratorWishlistRequestSchema>;

const PostCuratorWishlistResponseSchema = z.unknown();

export type PostCuratorWishlistResponse = z.infer<typeof PostCuratorWishlistResponseSchema>;

export const postCuratorWishlist = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PostCuratorWishlistRequestSchema),
    async ({ curatorId, platform, brandId }: PostCuratorWishlistRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.post<PostCuratorWishlistResponse>(
          partnerApiPath.curatorWishlist(curatorId),
          undefined,
          { params: { platform, brandId } },
        ),
      ),
    validateApiResponse(PostCuratorWishlistResponseSchema),
  ),
);
